/* @flow */
import React from 'react';
import { Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';

import { required } from '../../../../validators';

export default () => (
  <div>
    <Field name="id" component="input" type="hidden" />
    <Field
      name="name"
      component={TextField}
      floatingLabelText="Name"
      validate={[required]}
    />
    <br />
    <Field
      name="description"
      component={TextField}
      floatingLabelText="Description"
      validate={[required]}
    />
    <br />
    <Field
      name="referralCode"
      component={TextField}
      floatingLabelText="Referral Code"
      validate={[required]}
    />
    <br />
    <Field
      name="internalMargin"
      component={TextField}
      floatingLabelText="Internal Margin"
      validate={[required]}
    />
    <br />
    <Field
      name="externalMargin"
      component={TextField}
      floatingLabelText="External Margin"
      validate={[required]}
    />
    <br />
    <Field
      name="studentCount"
      component={TextField}
      readOnly
      floatingLabelText="Student Count"
    />
    <br />
  </div>
);



// WEBPACK FOOTER //
// ./src/modules/admin/company/components/TutoringCompanyForm.js